import { PUBLIC_PAGES } from '@belong/constants/src';
import { isNbnOrderReadyForResume } from '@belong/domain-nbn-core/utils';
import { FEATURES } from '@belong/feature-toggles';
import type { TSSPChain } from '@belong/ssp-execution';
import { TPublicSSPContext } from './types';

const NBN_CART_STATUS_EXCLUDED_LIST = [
  PUBLIC_PAGES.MOBILE_PLANS,
  PUBLIC_PAGES.DATA_PLANS,
  PUBLIC_PAGES.ACTIVE_SIM,
  PUBLIC_PAGES.ESIM,
  PUBLIC_PAGES.EXPLORE_MOBILE,
  PUBLIC_PAGES.INTERNATIONAL_ROAMING
];

export const getNbnCartStatusSSP: TSSPChain<TPublicSSPContext> = async ctx => {
  const { context, appServerSideProps, pagePath } = ctx;

  const isFeatureEnabled = appServerSideProps.features[FEATURES.NBN_CLIENT_SIDE_RESUMPTION_CART];

  let isNbnOrderCartReady = false;

  if (isFeatureEnabled) {
    // Exclude the mobile and data plans pages
    const isExcludedPage =
      NBN_CART_STATUS_EXCLUDED_LIST.includes(pagePath) || pagePath.startsWith(PUBLIC_PAGES.MOBILE_PLANS);

    isNbnOrderCartReady = !isExcludedPage && isNbnOrderReadyForResume(context);
  }

  return {
    ...ctx,
    isNbnOrderCartReady
  };
};
